import { Controller } from "@hotwired/stimulus";

// Copies the value of one field into all the (enabled) fields of a list.
export default class extends Controller {
  static targets = ["value", "field"];

  apply(event) {
    event.preventDefault();
    const value = this.valueTarget.value;
    if (!value) return;
    this.fieldTargets.forEach((field) => {
      if (!field.disabled) field.value = value;
    });
  }
}
